import _classCallCheck from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */
import { Service, Container, Blob, PageBlob, AppendBlob, BlockBlob } from "./operations";
import { StorageClientContext } from "./storageClientContext";
export var StorageClient = /*#__PURE__*/function (_StorageClientContext) {
  _inherits(StorageClient, _StorageClientContext);

  /**
   * Initializes a new instance of the StorageClient class.
   * @param url The URL of the service account, container, or blob that is the target of the desired
   *            operation.
   * @param options The parameter options
   */
  function StorageClient(url, options) {
    var _this;

    _classCallCheck(this, StorageClient);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(StorageClient).call(this, url, options));
    _this.service = new Service(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.container = new Container(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.blob = new Blob(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.pageBlob = new PageBlob(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.appendBlob = new AppendBlob(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.blockBlob = new BlockBlob(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  return StorageClient;
}(StorageClientContext);